import {
    CheckCircle,
    Close
} from "@mui/icons-material";
import {
    Box,
    Button,
    Dialog,
    IconButton,
    Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { tokens } from "../../../../../../theme";

export interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  open,
  onClose,
  title = "Comment Sent Successfully!",
  message = "Your comment has been submitted and is awaiting approval. It will appear once it has been reviewed.",
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 1,
        },
      }}
    >
      <Box sx={{ position: "relative", px: 3, py: 4 }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: colors.neutral?.[600] || "text.secondary",
          }}
        >
          <Close fontSize="small" />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              backgroundColor: colors.primary[800],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircle sx={{ fontSize: 52, color: colors.primary[400] }} />
          </Box>
        </Box>

        <Typography variant="h6" align="center" sx={{ fontWeight: 700, mb: 1 }}>
          {title}
        </Typography>

        <Typography
          align="center"
          sx={{ color: colors.primary[100], mb: 3, px: 1 }}
        >
          {message}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              px: 4.5,
              py: 1.2,
              fontWeight: 600,
            }}
          >
            Got it
          </Button>
        </Box>

        {/* <Stack spacing={1.5}>
          <Box
            component="a"
            href="#"
            onClick={(e) => e.preventDefault()}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              textDecoration: "none",
              color: "inherit",
              border: `1px solid ${colors.neutral?.[300] || "#E0E0E0"}`,
              borderRadius: "10px",
              px: 2,
              py: 1.25,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: colors.neutral?.[100] || "#FAFAFA",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Restaurant fontSize="small" sx={{ color: "#1E8E3E" }} />
              <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
                Order a frozen meal
              </Typography>
            </Box>
            <ChevronRight fontSize="small" sx={{ color: "text.secondary" }} />
          </Box>

          <Box
            component="a"
            href="#"
            onClick={(e) => e.preventDefault()}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              textDecoration: "none",
              color: "inherit",
              border: `1px solid ${colors.neutral?.[300] || "#E0E0E0"}`,
              borderRadius: "10px",
              px: 2,
              py: 1.25,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: colors.neutral?.[100] || "#FAFAFA",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Photo fontSize="small" sx={{ color: "#1E8E3E" }} />
              <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
                Learn more about our Pixel Pilot Program
              </Typography>
            </Box>
            <ChevronRight fontSize="small" sx={{ color: "text.secondary" }} />
          </Box>
        </Stack> */}
      </Box>
    </Dialog>
  );
};

export default SuccessModal;
